import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { basketSelectors } from '@store/basket/selectors';
import { createBasket, updateBasket, fetchBasketDetails } from '@store/basket/actions';
import { entitySelectors } from '@store/entity/selectors';
import { settingSelectors } from '@store/setting/selectors';

import { DiningReservationV2 } from './DiningReservationV2';
import type { DiningReservationV2DispatchProps } from './DiningReservationV2.types';

const mapStateToProps = (state: any) => ({
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
  language: (settingSelectors.getUserLanguage(state) as string | undefined) ?? 'en',
});

const mapDispatchToProps = (dispatch: any): DiningReservationV2DispatchProps =>
  bindActionCreators(
    { createBasket, updateBasket, fetchBasketDetails },
    dispatch
  ) as unknown as DiningReservationV2DispatchProps;

export const DiningReservationV2Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(DiningReservationV2);
